import { useApplicationDetails } from "../../hooks/application";
import { useApplicationSettings } from "../application-settings/hooks";
import { useSignInformation } from "../sign-page/hooks/hooks";
import { getAssignedFullAccesUsers, getUnassignedRepresentatives } from "./helpers";

export const useFullAccessUsers = () => {
	const { fullAccessUsers, isLoading: fullAccessUserLoading } = useApplicationSettings();
	const { applicant, representatives, currentUserNationalId } = useApplicationDetails();
	const { signatories } = useSignInformation();

	const applicantData = representatives?.find(
		(individual) => individual.nationalId === applicant?.nationalId,
	);

	const assignedFullAccesUsers = getAssignedFullAccesUsers(applicantData, fullAccessUsers);

	const unassignedRepresentatives = getUnassignedRepresentatives(
		representatives,
		assignedFullAccesUsers,
		signatories ?? [],
	);

	const canDeleteUsers = assignedFullAccesUsers.length > 1;
	const canAddUsers = unassignedRepresentatives.length > 0;
	const canManageFullAccessUsers = canDeleteUsers || canAddUsers;

	const isLoading = fullAccessUserLoading;
	return {
		fullAccessUsers,
		fullAccessUserLoading,
		applicant,
		applicantData,
		representatives,
		signatories,
		currentUserNationalId,
		assignedFullAccesUsers,
		unassignedRepresentatives,
		canManageFullAccessUsers,
		isLoading,
	};
};
